import { Loader2 } from 'lucide-react';
import { clsx } from 'clsx';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  const sizes = {
    sm: 16,
    md: 24,
    lg: 32,
  };

  return (
    <div className={clsx('text-brand-primary flex items-center justify-center', className)}>
      <Loader2 className="shrink-0 animate-spin [color:inherit]" size={sizes[size]} />
    </div>
  );
}
